import React from 'react';
import Component from '@/Component';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class AddExcept extends Component {

  onChangeHour(e) {
    this.props._updateSelfExceptHour(e.target.value)
  }

  onChangeMinute(e) {
    this.props._updateSelfExceptMinute(e.target.value)
  }

  onClickDelete() {
    this.props._deleteSelfExcept();
  }

  onClickSave() {
    this.props._saveSelfExcept();
  }

  render() {
    const {
      isOpen,
      hour,
      minute,
      _closeAddExcept,
    } = this.props;

    return (
      <div>
        <Modal isOpen={isOpen} toggle={_closeAddExcept} backdrop="static" centered={true}>
          <ModalHeader toggle={_closeAddExcept}>추가 제외시간 저장</ModalHeader>
          <ModalBody>
            <div className="input-group" style={{display: 'flex'}}>
              <input type="number" className="form-control" value={hour} onChange={this.onChangeHour} min="0" max="14" />
              <span style={{margin: 5}}>시 </span>
              <input type="number" className="form-control" value={minute} onChange={this.onChangeMinute} min="0" max="59" />
              <span style={{margin: 5}}>분</span>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="default" onClick={_closeAddExcept}>Close</Button>
            <Button color="danger" onClick={this.onClickDelete}>Delete</Button>
            <Button color="primary" onClick={this.onClickSave}>Save</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default AddExcept;



// WEBPACK FOOTER //
// ./src/components/main/AddExcept.js